module.exports = __webpack_public_path__ + "img/triangle4red.44c5e6e2.png";